import { jsx } from "panel";
import { selx } from "clsx";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import styles from "./index.module.styl";
export function template() {
  return /* @__PURE__ */ jsx("div", { sel: selx(styles.mpInputLabelContainer), "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("label", { sel: selx(styles.mpInputLabel), attrs: {
    for: this.attr("field-id")
  } }, this.attr("label")), this.attr("necessary") ? /* @__PURE__ */ jsx("span", { sel: selx(styles.mpInputNecessary) }, this.attr("necessary")) : null, this.attr("help-text") ? /* @__PURE__ */ jsx("div", { sel: selx(styles.mpInputHelpIcon) }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "info"
  } }), /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    "max-width": "500px"
  } }, this.attr("help-text"))) : null, this.attr("extra-info") ? /* @__PURE__ */ jsx("div", { sel: selx(styles.mpInputExtraInfo) }, this.attr("extra-info")) : null);
}
